<template>
  <header>
    <nav class="nav-bar bg-primary">
      <h1>
        <router-link to="/">
          <img class="logo" src="../../static/thetapulse-logo-white.png" alt="Thetapulse Logo">
        </router-link>
      </h1>
  
      <!-- Mobile menu button -->
      <button class="mobile-menu-btn" @click="toggleMobileMenu" aria-label="Toggle menu">
        <v-icon size="24" color="white">{{ mobileMenuOpen ? 'mdi-close' : 'mdi-menu' }}</v-icon>
      </button>
  
      <!-- Desktop menu -->
      <ul class="nav-items desktop-menu" style="list-style: none; gap: 40px; margin: 0;">
        <!-- Show only Login if not logged in -->
        <li v-if="!isLoggedIn">
          <router-link to="/user/login" class="nav-link" active-class="active-link" @click="closeMobileMenu">
            Login
          </router-link>
        </li>
  
        <!-- Show rest of menu if logged in -->
        <template v-else>
          <li>
            <router-link to="/trades/tradeView" class="nav-link" active-class="active-link" @click="closeMobileMenu">
              Live Trades
            </router-link>
          </li>
          
          <li>
            <v-menu offset-y>
              <template #activator="{ props, isActive }">
                <span v-bind="props" class="nav-link" :class="{ 'active-link': isActive }" style="cursor: pointer;">
                  <span class="d-flex align-center">
                    Covered Call
                    <v-icon size="18" class="ml-1">mdi-chevron-down</v-icon>
                  </span>
                </span>
              </template>
              <v-list>
                <v-list-item to="/coveredcall/CoveredCallList" link @click="closeMobileMenu">
                  <v-list-item-title>List</v-list-item-title>
                </v-list-item>
                <v-list-item to="/coveredcall/CoveredCallDetails" link @click="closeMobileMenu">
                  <v-list-item-title>Details</v-list-item-title>
                </v-list-item>
                <v-list-item to="/coveredcall/CoveredCallNew" link @click="closeMobileMenu">
                  <v-list-item-title>New</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </li>
          <li>
            <v-menu offset-y>
              <template #activator="{ props, isActive }">
                <span v-bind="props" class="nav-link" :class="{ 'active-link': isActive }" style="cursor: pointer;">
                  <span class="d-flex align-center">
                    Portfolio
                    <v-icon size="18" class="ml-1">mdi-chevron-down</v-icon>
                  </span>
                </span>
              </template>
              <v-list>
                <v-list-item to="/portfolio/portfolioList" link @click="closeMobileMenu">
                  <v-list-item-title>List</v-list-item-title>
                </v-list-item>
                <v-list-item to="/strategy/portfolioStrategy" link @click="closeMobileMenu">
                  <v-list-item-title>Strategy</v-list-item-title>
                </v-list-item>
                <v-list-item to="/portfolio/portfolioDetail" link @click="closeMobileMenu">
                  <v-list-item-title>Details</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </li>
          <li>
            <v-menu offset-y>
              <template #activator="{ props, isActive }">
                <span v-bind="props" class="nav-link" :class="{ 'active-link': isActive }" style="cursor: pointer;">
                  <span class="d-flex align-center">
                    Trades
                    <v-icon size="18" class="ml-1">mdi-chevron-down</v-icon>
                  </span>
                </span>
              </template>
              <v-list>
                <v-list-item to="/trades" link @click="closeMobileMenu">
                  <v-list-item-title>Manage Trades</v-list-item-title>
                </v-list-item>
                <v-list-item to="/trades/tradeView" link @click="closeMobileMenu">
                  <v-list-item-title>Live Trades</v-list-item-title>
                </v-list-item>
                <v-list-item to="/trades/pastTrades" link @click="closeMobileMenu">
                  <v-list-item-title>Past Trades</v-list-item-title>
                </v-list-item>
                <v-list-item to="/trades/newTrades" link @click="closeMobileMenu">
                  <v-list-item-title>New Trades</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </li>
  
          <li>
            <router-link to="/positions" class="nav-link" active-class="active-link" @click="closeMobileMenu">
              Positions
            </router-link>
          </li>
          <li>
            <router-link to="/orders" class="nav-link" active-class="active-link" @click="closeMobileMenu">
              Orders
            </router-link>
          </li>
  
          <li>
            <router-link to="/user/token" class="nav-link" active-class="active-link" @click="closeMobileMenu">
              Setup
            </router-link>
          </li>
          <li>
            <span class="nav-link" style="cursor: pointer;" @click="logout">Logout</span>
          </li>
          <li>
            <router-link to="/mf" class="nav-link" active-class="active-link" @click="closeMobileMenu">
              MF
            </router-link>
          </li>
        </template>
      </ul>
  
      <!-- Mobile menu overlay -->
      <div v-if="mobileMenuOpen" class="mobile-menu-overlay" @click="closeMobileMenu"></div>
  
      <!-- Mobile menu -->
      <transition name="slide-down">
        <ul v-if="mobileMenuOpen" class="nav-items mobile-menu" style="list-style: none; margin: 0;">
          <!-- Show only Login if not logged in -->
          <li v-if="!isLoggedIn">
            <router-link to="/user/login" class="nav-link mobile-nav-link" active-class="active-link"
              @click="closeMobileMenu">
              Login
            </router-link>
          </li>
  
          <!-- Show rest of menu if logged in -->
          <template v-else>
            <li>
              <router-link to="/trades/tradeView" class="nav-link mobile-nav-link" active-class="active-link"
                @click="closeMobileMenu">
                Live Trades
              </router-link>
            </li>
  
            <!-- Portfolio submenu for mobile -->
               <li class="mobile-submenu">
              <div class="nav-link mobile-nav-link submenu-header" @click="toggleSubmenu('portfolio')">
                <span class="d-flex align-center justify-space-between">
                  Covered Call
                  <v-icon size="18">{{ submenus.portfolio ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </span>
              </div>
              <div v-if="submenus.portfolio" class="submenu-items">
                <router-link to="/coveredcall/CoveredCallList" class="submenu-link" @click="closeMobileMenu">
                  List
                </router-link>
                <router-link to="/coveredcall/CoveredCallDetails" class="submenu-link" @click="closeMobileMenu">
                  Details
                </router-link>
                <router-link to="/coveredcall/CoveredCallNew" class="submenu-link" @click="closeMobileMenu">
                  New
                </router-link>
              </div>
            </li>
            <li class="mobile-submenu">
              <div class="nav-link mobile-nav-link submenu-header" @click="toggleSubmenu('portfolio')">
                <span class="d-flex align-center justify-space-between">
                  Portfolio
                  <v-icon size="18">{{ submenus.portfolio ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </span>
              </div>
              <div v-if="submenus.portfolio" class="submenu-items">
                <router-link to="/portfolio/portfolioList" class="submenu-link" @click="closeMobileMenu">
                  List
                </router-link>
                <router-link to="/strategy/portfolioStrategy" class="submenu-link" @click="closeMobileMenu">
                  Strategy
                </router-link>
                <router-link to="/portfolio/portfolioDetail" class="submenu-link" @click="closeMobileMenu">
                  Details
                </router-link>
              </div>
            </li>
  
            <!-- Trades submenu for mobile -->
            <li class="mobile-submenu">
              <div class="nav-link mobile-nav-link submenu-header" @click="toggleSubmenu('trades')">
                <span class="d-flex align-center justify-space-between">
                  Trades
                  <v-icon size="18">{{ submenus.trades ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </span>
              </div>
              <div v-if="submenus.trades" class="submenu-items">
                <router-link to="/trades" class="submenu-link" @click="closeMobileMenu">
                  Manage Trades
                </router-link>
                <router-link to="/trades/tradeView" class="submenu-link" @click="closeMobileMenu">
                  Live Trades
                </router-link>
                <router-link to="/trades/pastTrades" class="submenu-link" @click="closeMobileMenu">
                  Past Trades
                </router-link>
                <router-link to="/trades/newTrades" class="submenu-link" @click="closeMobileMenu">
                  New Trades
                </router-link>
              </div>
            </li>
  
            <li>
              <router-link to="/positions" class="nav-link mobile-nav-link" active-class="active-link"
                @click="closeMobileMenu">
                Positions
              </router-link>
            </li>
            <li>
              <router-link to="/orders" class="nav-link mobile-nav-link" active-class="active-link"
                @click="closeMobileMenu">
                Orders
              </router-link>
            </li>
            <li>
              <router-link to="/user/token" class="nav-link mobile-nav-link" active-class="active-link"
                @click="closeMobileMenu">
                Setup
              </router-link>
            </li>
            <li>
              <router-link to="/mf" class="nav-link mobile-nav-link" active-class="active-link" @click="closeMobileMenu">
                MF
              </router-link>
            </li>
            <li>
              <span class="nav-link mobile-nav-link" style="cursor: pointer;" @click="logout">Logout</span>
            </li>
          </template>
        </ul>
      </transition>
    </nav>
  </header>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const store = useStore()
const isLoggedIn = computed(() => store.state.users.isLoggedIn)

const mobileMenuOpen = ref(false)
const submenus = ref({
  portfolio: false,
  trades: false
})

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
  // Reset submenus when closing mobile menu
  if (!mobileMenuOpen.value) {
    submenus.value.portfolio = false
    submenus.value.trades = false
  }
}

const closeMobileMenu = () => {
  mobileMenuOpen.value = false
  submenus.value.portfolio = false
  submenus.value.trades = false
}

const toggleSubmenu = (menu) => {
  submenus.value[menu] = !submenus.value[menu]
}

const logout = () => {
  store.dispatch('users/logout');
  closeMobileMenu();
  router.push('/user/login');
}
</script> 

<style scoped>
.nav-bar {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  background-color: #1976d2;
  position: relative;
}

.logo {
  width: 15%;
  height: auto;
  object-fit: contain;
  display: block;
}

/* Desktop menu styles */
.desktop-menu {
  display: flex;
  align-items: center;
  gap: 24px;
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Mobile menu button */
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
}

/* Mobile menu styles */
.mobile-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #1976d2;
  flex-direction: column;
  gap: 0;
  padding: 0;
  z-index: 1001;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

/* Common nav-link styles */
.nav-link {
  color: white;
  text-decoration: none;
  padding: 6px 12px;
  font-weight: 500;
  border: 2px solid transparent;
  border-radius: 4px;
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 14px;
  white-space: nowrap;
}

/* Mobile specific nav-link styles */
.mobile-nav-link {
  display: block;
  padding: 16px 24px;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  text-align: left;
}

.mobile-nav-link:last-child {
  border-bottom: none;
}

/* Mobile submenu styles */
.mobile-submenu {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.submenu-header {
  cursor: pointer;
  border-bottom: none !important;
}

.submenu-items {
  background-color: rgba(255, 255, 255, 0.1);
  padding: 0;
}

.submenu-link {
  display: block;
  color: white;
  text-decoration: none;
  padding: 12px 36px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 14px;
}

.submenu-link:last-child {
  border-bottom: none;
}

.submenu-link:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

/* Highlight current/active route or open dropdown */
.active-link {
  border: 2px solid white;
}

.mobile-nav-link.active-link {
  border: none;
  background-color: rgba(255, 255, 255, 0.2);
}

/* Slide down animation for mobile menu */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* Responsive design */
@media (max-width: 768px) {
  .nav-bar {
    padding: 0 16px;
  }

  .logo {
    width: 120px;
    /* Fixed size for mobile */
  }

  .mobile-menu-btn {
    display: block;
  }

  .desktop-menu {
    display: none;
  }

  .mobile-menu {
    display: flex;
  }
}

@media (min-width: 769px) {
  .mobile-menu {
    display: none !important;
  }

  .mobile-menu-overlay {
    display: none;
  }
}
</style>